import React from "react";
import { Button, ButtonProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledButton = styled(Button)(({ theme }) => ({
  width: "fit-content",
  background: theme.palette.secondary.main,
  borderRadius: "52px",
  paddingLeft: "30px",
  paddingRight: "30px",
  color: theme.palette.primary.main,
  "&:hover": {
    background: theme.palette.text.secondary,
  },
}));

interface ReserveASpotButtonProps extends ButtonProps {}

const OrangeHighlightButton: React.FC<ReserveASpotButtonProps> = (props) => {
  return <StyledButton {...props}>{props.children}</StyledButton>;
};

export default OrangeHighlightButton;
